import { createAsyncThunk } from '@reduxjs/toolkit';
import type { PlataformaStatusResponse } from '../../types/plataforma';
import { plataformaStatusService } from './services';

export const fetchPlataformaStatus = createAsyncThunk<
  PlataformaStatusResponse,
  void,
  { rejectValue: string }
>('plataformaStatus/fetch', async (_, { rejectWithValue }) => {
  try {
    return await plataformaStatusService.getStatus();
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'Erro ao carregar status da plataforma',
    );
  }
});
